var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sergio-de-paula-c_GmwfHBDzk-unsplash-2",
    "data-name": "sergio-de-paula-c_GmwfHBDzk-unsplash",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "sergio-de-paula-c_GmwfHBDzk-unsplash",
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sergio-de-paula-c_GmwfHBDzk-unsplash-3",
    "data-name": "sergio-de-paula-c_GmwfHBDzk-unsplash",
    fill: "#1a1a1a",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7_8",
    "data-name": "\\u30DE\\u30B9\\u30AF\\u30B0\\u30EB\\u30FC\\u30D7 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M38,38A16,16,0,1,0,22,22,16,16,0,0,0,38,38Zm0,8C27.32,46,6,51.36,6,62v8H70V62C70,51.36,48.68,46,38,46Z",
    transform: "translate(22.03 22.03)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAvatar);
export default __webpack_public_path__ + "static/media/no-avatar.efdc32351ed1cd28eaa8163cf40d4258.svg";
export { ForwardRef as ReactComponent };